export const formatTemplateValues = (values) => {
  const formattedValues = {};
  Object.keys(values).forEach((key) => {
    const value = values[key];
    if (Array.isArray(value)) {
      const arrayOfValues = value.map((e) => e?.value || e);
      formattedValues[key] = arrayOfValues.toString();
    } else {
      formattedValues[key] = value;
    }
  });
  return formattedValues;
};

export const addSpaceAfterMarks = (string) => string.replace(/([,.])/g, '$1 ');
